<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card :loading="loading" :disabled="cardDisabled">
        <v-card-title>
          <span class="headline">{{ $t("Update Role") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert
              text
              prominent
              dismissible
              v-model="alertShow"
              type="error"
              icon="mdi-alert"
              >{{ alertText }}</v-alert
            >
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :label="nameLabel"
                    :rules="nameRules"
                    :error-messages="errorMessages"
                    v-model="inputName"
                    :class="{ 'disable-events': !updateEnable }"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="descriptionLabel"
                    :rules="descriptionRules"
                    v-model="description"
                    :class="{ 'disable-events': !updateEnable }"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col v-if="typeSelection == 'user'" cols="12">
                  <v-card class="mx-auto">
                    <v-card-title>{{ $t("Resources") }}</v-card-title>
                    <v-card-text>
                      <v-treeview
                        v-model="resourcesSelection"
                        selectable
                        selected-color="primary"
                        :items="resources"
                      ></v-treeview>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="typeSelection == 'token'" cols="12">
                  <v-card>
                    <v-card-title>
                      {{ $t("Rules") }}
                      <v-spacer></v-spacer>
                      <v-btn @click="addRule" v-if="updateEnable">+</v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">{{ $t("Rule") }}</th>
                              <th class="text-left">{{ $t("Object") }}</th>
                              <th class="text-left">{{ $t("Action") }}</th>
                              <th class="text-left"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in rules" :key="item.rule">
                              <td>#{{ item.rule }}</td>
                              <td>
                                <v-text-field
                                  v-model="item.obj"
                                  :class="{ 'disable-events': !updateEnable }"
                                  :id="'object-' + item.rule"
                                  style="min-width: 150px"
                                ></v-text-field>
                              </td>
                              <td>
                                <v-btn-toggle
                                  v-model="item.act"
                                  :class="{ 'disable-events': !updateEnable }"
                                  :id="'action-' + item.rule"
                                  multiple
                                >
                                  <v-btn value="GET">GET</v-btn>
                                  <v-btn value="POST">POST</v-btn>
                                  <v-btn value="PUT">PUT</v-btn>
                                  <v-btn value="DELETE">DELETE</v-btn>
                                </v-btn-toggle>
                              </td>
                              <td>
                                <v-btn
                                  icon
                                  color="red"
                                  v-if="updateEnable"
                                  @click="removeRule(item)"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col></v-col>
                <v-col cols="12" class="outlinedButton">
                  <v-btn
                    class="ma-2"
                    tile
                    outlined
                    color="red"
                    v-if="deleteEnable"
                    @click="deleteRole"
                  >
                    <v-icon left>mdi-delete</v-icon>
                    {{ $t("Delete Role") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="hide">{{ $t("close") }}</v-btn>
          <v-btn
            color="darken-1"
            text
            @click="updateRole"
            v-if="updateEnable"
            :disabled="!valid"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import i18n from "../../../i18n";
import EventBus from "../../../event-bus";

export default {
  name: "UpdateRoleModal",
  props: {},
  data: () => ({
    valid: true,
    showModal: false,
    loading: true,
    cardDisabled: true,
    alertText: null,
    alertShow: false,
    id: "",
    name: "",
    nameLabel: i18n.t("Name"),
    inputName: "",
    descriptionLabel: i18n.t("Description"),
    description: "",
    errorMessages: [],
    nameRules: [],
    descriptionRules: [],
    typeSelection: null,
    resources: [],
    resourcesSelection: [],
    rules: [],
    updateEnable: false,
    deleteEnable: false,
  }),
  created() {
    this.nameRules = [
      (v) => !!v || i18n.t("Name is required"),
      (v) => v.length <= 50 || i18n.t("Max 50 characters"),
      (v) => (v || "").indexOf(" ") < 0 || i18n.t("No spaces are allowed"),
      (v) =>
        /^[0-9a-zA-Z-_]+$/.test(v) ||
        i18n.t("Only alphanumeric characters and dash allowed"),
    ];
    this.descriptionRules = [
      (v) =>
        typeof v == "undefined" ||
        v.length <= 100 ||
        i18n.t("Max 100 characters"),
    ];
  },
  watch: {
    inputName: function (val) {
      if (val != this.name && val != "" && /^[0-9a-zA-Z-_]+$/.test(val)) {
        axios
          .get("/api/v1/permissions/rolename/" + val)
          .then((response) => {
            if (
              !response.data ||
              !response.data.status ||
              !(response.data.status == "done")
            ) {
              this.errorMessages = [];
            } else {
              if (response.data.username) {
                this.errorMessages = [i18n.t("Role already exists!")];
              } else {
                this.errorMessages = [];
              }
            }
          })
          .catch(() => {
            this.errorMessages = [];
          });
      }
    },
  },
  mounted() {
    // Permissions
    if (typeof this.$store.getters.resources.permissions !== "undefined") {
      let permissions = this.$store.getters.resources.permissions;

      if (this.checkNested(permissions, "roles", "delete")) {
        this.deleteEnable = true;
      }

      if (this.checkNested(permissions, "roles", "update")) {
        this.updateEnable = true;
      }
    }
  },
  methods: {
    sendErrorAndCloseModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }

      this.loading = false;
      this.showModal = false;
    },
    sendErrorOnModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          this.alertText = error.response.data.error;
        } else {
          this.alertText = error.response.data;
        }
      } else {
        this.alertText = error;
      }

      this.loading = false;
      this.alertShow = true;
    },
    setObject(obj, path, value) {
      obj = typeof obj === "object" ? obj : {};
      let keys = Array.isArray(path) ? path : path.split(".");
      let curStep = obj;

      for (let i = 0; i < keys.length - 1; i++) {
        var key = keys[i];

        if (
          !curStep[key] &&
          !Object.prototype.hasOwnProperty.call(curStep, key)
        ) {
          let nextKey = keys[i + 1];
          let useArray = /^\+?(0|[1-9]\d*)$/.test(nextKey);
          curStep[key] = useArray ? [] : {};
        }

        curStep = curStep[key];
      }

      let finalStep = keys[keys.length - 1];
      curStep[finalStep] = value;
    },
    getObject(source) {
      let result = [];

      (function flat(obj, stack) {
        Object.keys(obj).forEach(function (k) {
          let s = stack.concat([k]);
          let v = obj[k];

          if (typeof v === "object") flat(v, s);
          else result.push(s.join("."));
        });
      })(source, []);

      return result;
    },
    show(id) {
      this.resources = [];
      this.rules = [];
      this.alertShow = false;
      this.alertText = "";
      this.showModal = true;
      this.id = id;

      let getRole = axios.get("/api/v1/permissions/role/" + id);
      let getResources = axios.get("/api/v1/permissions/roles/resources");

      axios
        .all([getRole, getResources])
        .then(
          axios.spread((...responses) => {
            const role = responses[0];
            const resources = responses[1];

            if (role.data.status == "done" && resources.data.status == "done") {
              this.loading = false;
              this.cardDisabled = false;

              this.name = role.data.role.name;
              this.inputName = role.data.role.name;

              // To avoid undefined data if description does not exists.
              if ("description" in role.data.role) {
                this.description = role.data.role.description;
              }

              if (role.data.role.gui) {
                this.typeSelection = "user";
                this.resources = resources.data.list;

                // Disable treeview update.
                if (this.updateEnable == false) {
                  for (let i = 0; i < this.resources.length; i++) {
                    this.resources[i].disabled = true;
                  }
                }

                this.resourcesSelection = this.getObject(
                  role.data.role.resources
                );
              } else {
                this.typeSelection = "token";
                let rules = role.data.role.rules;

                if (typeof rules !== "undefined") {
                  let newRules = [];

                  for (let i = 0; i < rules.length; i++) {
                    let act;

                    if (rules[i].act == "*") {
                      act = ["GET", "POST", "PUT", "DELETE"];
                    } else {
                      act = rules[i].act.split("|");
                    }

                    newRules.push({
                      rule: i + 1,
                      obj: rules[i].obj,
                      act: act,
                    });
                  }

                  this.rules = newRules;
                }
              }
            } else {
              this.sendErrorAndCloseModal(
                i18n.t("Error retrieving resources/role request!")
              );
            }
          })
        )
        .catch((errors) => {
          this.sendErrorAndCloseModal(errors);
        });
    },
    addRule() {
      this.rules.push({
        rule: this.rules.length + 1,
        obj: "",
        act: [],
      });
    },
    removeRule(val) {
      let newRules = [];

      for (let i = 0; i < this.rules.length; i++) {
        if (val.rule != i + 1) {
          newRules.push(this.rules[i]);
          newRules[newRules.length - 1].rule = newRules.length;
        }
      }

      this.rules = newRules;
    },
    updateRole() {
      this.loading = true;
      let data = {};
      data.name = this.name;
      data.description = this.description;

      if (this.typeSelection == "user") {
        // Get resource json.
        let resourcesJson = {};

        for (let i = 0; i < this.resourcesSelection.length; i++) {
          this.setObject(resourcesJson, this.resourcesSelection[i], true);
        }

        data.gui = true;
        data.resources = resourcesJson;
      } else {
        // Get rules json.
        let rulesJson = [];

        for (let i = 0; i < this.rules.length; i++) {
          let act;
          let first = true;

          if (
            this.rules[i].act.includes("GET") &&
            this.rules[i].act.includes("POST") &&
            this.rules[i].act.includes("PUT") &&
            this.rules[i].act.includes("DELETE")
          ) {
            act = "*";
          } else {
            if (this.rules[i].act.includes("GET")) {
              act = "GET";
              first = false;
            }

            if (this.rules[i].act.includes("POST")) {
              if (first) {
                act = "POST";
              } else {
                act += "|POST";
                first = false;
              }
            }

            if (this.rules[i].act.includes("PUT")) {
              if (first) {
                act = "PUT";
              } else {
                act += "|PUT";
                first = false;
              }
            }

            if (this.rules[i].act.includes("DELETE")) {
              if (first) {
                act = "DELETE";
              } else {
                act += "|DELETE";
                first = false;
              }
            }
          }

          // Avoid adding empty rules.
          if (
            typeof this.rules[i].obj !== "undefined" &&
            this.rules[i].obj != ""
          ) {
            rulesJson.push({
              obj: this.rules[i].obj,
              act: typeof act === "undefined" ? "GET" : act,
            });
          }
        }

        data.gui = false;
        data.rules = rulesJson;
      }

      axios
        .put("/api/v1/permissions/role/" + this.id, data)
        .then((response) => {
          this.loading = false;
          this.showModal = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.showModal = false;
            EventBus.$emit("SHOW_ERROR", response);
          } else {
            this.$parent.$parent.updateTable();
          }
        })
        .catch((error) => {
          this.sendErrorOnModal(error);
        });
    },
    deleteRole() {
      this.loading = true;

      axios
        .delete("/api/v1/permissions/role/" + this.id)
        .then((response) => {
          this.loading = false;
          this.showModal = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            EventBus.$emit("SHOW_ERROR", response);
          } else {
            this.$parent.$parent.updateTable();
          }
        })
        .catch((error) => {
          this.sendErrorAndCloseModal(error);
        });
    },
    hide() {
      this.showModal = false;
    },
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};
</script>

<style scoped>
.v-alert {
  overflow: hidden;
}

.outlinedButton {
  padding: 0px !important;
}

.disable-events {
  pointer-events: none;
}
</style>